import { Box, Grid } from "@mui/material";
import { times } from "lodash";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import { Colors } from "../../../styles/constant";
import ProductCardSkeleton from "./ProductCardSkeleton";

const NewOfferingSkeleton = () => {
  return (
    <Box
      padding="1rem 1rem"
      sx={{ backgroundColor: Colors.bgGray }}
      marginTop="2rem"
      borderRadius="1rem"
    >
      <CustomShimmer width="70%" height="1rem" borderRadius=".25rem" />
      <Grid container rowGap=".75rem" marginTop="1rem">
        {times(8, (index) => {
          return (
            <Grid item xs={3} key={index}>
              <ProductCardSkeleton />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default NewOfferingSkeleton;
